//
// Copyright (c) 2020 Nutanix Inc. All rights reserved.
//
// WelcomeBanner - Contains the components that make up the "Welcome banner" modal.
//

// libs
import React from 'react';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify/dist/purify';

// components
import { Modal, Button, Paragraph, FlexLayout, StackingLayout } from '@nutanix-ui/prism-reactjs';
// CHANGE LATER TO USE ntnx-I18n library
import getI18nService from '../../i18n/I18n';
import './WelcomeBanner.less';

// CHANGE LATER TO USE ntnx-I18n library
const i18n = getI18nService();

const WELCOME_BANNER_TITLE = 'Terms and Conditions';

const sanitizeBannerHTMLContent = htmlContent => {
    return DOMPurify.sanitize(htmlContent, { USE_PROFILES: { html: true } });
};

class WelcomeBanner extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const { bannerMessage, bannerHTMLContent, bannerStatus, onHandleCloseBanner } = this.props;
        const customFooter = (
            <FlexLayout justifyContent="center">
                <Button
                    id="accept-terms-btn"
                    data-test="welcomeBannerButtonAccpetTerms"
                    onClick={onHandleCloseBanner}
                >
                    {i18n.t('HomePage.acceptTerms')}
                </Button>
            </FlexLayout>
        );
        return (
            <Modal
                data-testid="welcome-modal"
                id="welcome-banner"
                title={WELCOME_BANNER_TITLE}
                visible={bannerStatus}
                width={500}
                footer={customFooter}
                headerActions={[]}
            >
                <StackingLayout className="welcom-banner-inner">
                    {bannerMessage?.length > 0 && <Paragraph>{bannerMessage}</Paragraph>}
                    {bannerHTMLContent?.length > 0 && (
                        <div
                            dangerouslySetInnerHTML={{
                                __html: sanitizeBannerHTMLContent(bannerHTMLContent),
                            }}
                        />
                    )}
                </StackingLayout>
            </Modal>
        );
    }
}

WelcomeBanner.propTypes = {
    bannerStatus: PropTypes.bool,
    bannerMessage: PropTypes.string,
    bannerHTMLContent: PropTypes.string,
    onHandleCloseBanner: PropTypes.func,
};

export default WelcomeBanner;
